/* Common/UserName.js */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { Link } from '~/lib/react-router-dom';

import { Box, Chip, Stack } from '@mui/material';

import UsersService from '~/services/UsersService';

import CopyableField from './CopyableField';
import Spinner from './Spinner';

class UserName extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      user: null,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { userId } = this.props;

    this.setState({ isLoading: true, user: null, error: null }, async () => {
      const isLoading = false;

      try {
        // todo: refactor later to add client-side cache
        const user = await UsersService.getUser(userId);

        this.setState({ isLoading, user, userId });
      } catch (error) {
        this.setState({ isLoading, error });
      }
    });
  };

  render() {
    const { isLoading, error, user, userId } = this.state;
    const { asLink, showRoles, asCopyable, ...rest } = this.props;

    // Container with fixed height to prevent layout shifts
    const fixedHeightContentContainer = (content) => (
      <Box
        sx={{
          minHeight: '20px', // Fixed height to prevent layout shifts
          display: 'flex',
          alignItems: 'center',
          lineHeight: '1.2',
        }}
      >
        {content}
      </Box>
    );

    if (isLoading) {
      return fixedHeightContentContainer(<Spinner size={16} inline />);
    }

    if (error) {
      return fixedHeightContentContainer(null);
    }

    const userLink = <Link to={`/users/${user.id_member}`}>{user.fullName ?? userId}</Link>;

    if (showRoles) {
      return (
        <Box>
          {fixedHeightContentContainer(userLink)}
          <Stack direction="row" flexWrap="wrap" gap={1}>
            {user.roles
              .sort((r1, r2) => r1.localeCompare(r2))
              .map((role) => (
                <Chip
                  sx={{
                    padding: '0 8px',
                    '& .MuiChip-label': {
                      overflow: 'visible',
                    },
                  }}
                  key={role}
                  label={role}
                />
              ))}
          </Stack>
        </Box>
      );
    }

    if (asLink) {
      return fixedHeightContentContainer(<Link to={`/users/${user.id_member}`}>{user.fullName ?? userId}</Link>);
    }

    if (asCopyable) {
      return fixedHeightContentContainer(<CopyableField label={user.fullName ?? userId} value={userId} {...rest} />);
    }

    return fixedHeightContentContainer(<span>{user.fullName ?? userId}</span>);
  }
}

UserName.propTypes = {
  userId: PropTypes.string,
  asLink: PropTypes.bool,
  showRoles: PropTypes.bool,
};

UserName.defaultProps = {
  asLink: false,
  showRoles: false,
};

export default UserName;
